import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { SITE } from "../lib/data";
import { POSTS } from "../lib/blog";

export const LinkedInInsights = () => {
  const featured = POSTS.slice(0, 3);
  return (
    <section data-testid="linkedin-insights" className="bg-[#1A1A1A] text-[#FDFBF7]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-28 md:py-36">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <p className="overline text-[#C19A6B]">Insights & Frameworks</p>
              <h2 className="font-serif-lux text-5xl md:text-7xl tracking-tight mt-3">
                Notes from the market
              </h2>
            </div>
            <div className="flex flex-wrap gap-3 self-start">
              <Link
                to="/insights"
                data-testid="insights-all-cta"
                className="inline-flex items-center gap-3 border border-[#FDFBF7] text-[#FDFBF7] btn-lux px-8 py-4 overline"
              >
                All insights <ArrowUpRight size={15} />
              </Link>
              <a
                href={SITE.socials.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid="insights-linkedin-cta"
                className="inline-flex items-center gap-3 border border-[#C19A6B] text-[#FDFBF7] btn-lux btn-lux-invert px-8 py-4 overline"
              >
                <Linkedin size={16} /> LinkedIn
              </a>
            </div>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {featured.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.1}>
              <Link
                to={`/insights/${post.slug}`}
                data-testid={`insight-card-${i}`}
                className="group flex flex-col h-full border border-[#333] hover:border-[#C19A6B] bg-[#1F1F1F] p-8 transition-colors duration-400"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="overline text-[#C19A6B]">{post.category}</span>
                  <span className="font-sans-lux text-xs text-[#8A8A8A]">{post.readTime}</span>
                </div>
                <h3 className="font-serif-lux text-3xl leading-[1.1] tracking-tight">{post.title}</h3>
                <p className="font-sans-lux text-sm text-[#B8B2A7] mt-5 leading-relaxed flex-1">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center gap-2 mt-8 overline text-[#FDFBF7] group-hover:text-[#C19A6B] transition-colors">
                  Read framework
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
